

































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import LogoutConfigStore from '@/store/LogoutConfigStore'

@Component
export default class ComponentRemuneracaoMedicaNavBar extends Vue {
  show: boolean = true;
  enableRotas: any[] = [
    { url: '/contratos', icone: 'library_books', texto: 'Contratos' },
    { url: '#', icone: 'gavel', texto: 'Regras' },
    { url: '#', icone: 'assignment', texto: 'Cadastros' },
    { url: '#', icone: 'storage', texto: 'Fontes' },
    { url: '#', icone: 'logout', texto: 'Sair' },
  ]

  get logoutConfigStore() {
    return getModule(LogoutConfigStore, this.$store)
  }

  async logout() {
    await this.logoutConfigStore.authLogout(this.$user.profile.sub)
  }

  disableRoute(texto: string) {
    const bool: boolean = texto.toLowerCase() !== 'contratos'
    return bool
  }

  toggleMenu() {
    //
  }
}
